import * as React from 'react';
import Row from 'react-bootstrap/Row';

import './style.scss';

interface IActivityToolbarProps {
  className?: string;
}

interface IActivityToolbarState {}

export default class ActivityToolbar extends React.Component<IActivityToolbarProps, IActivityToolbarState> {
  render() {
    const className = this.props.className ? this.props.className : '';
    const fixedClass = 'activity-toolbar';
    const hiddenClass = 'activity-toolbar__hidden-space';

    return (
      <div>
        <Row className={hiddenClass} />
        <Row className={`${className} ${fixedClass}`}>{this.props.children}</Row>
      </div>
    );
  }
}
